export enum ConstructionCluster {
  NONE = 'NONE',
  AUSTRALIA = 'AUSTRALIA',
  FRANCE = 'FRANCE',
  GERMANY = 'GERMANY',
  ITALY = 'ITALY',
  POLAND = 'POLAND',
  SPAIN_NETHERLANDS_GREECE = 'SPAIN_NETHERLANDS_GREECE',
  UK_IRELAND = 'UK_IRELAND',
}
export const consClusterToLabel: {[constructionCluster: string]: string} = {
  [ConstructionCluster.NONE]: 'Not within a defined Cluster',
  [ConstructionCluster.AUSTRALIA]: 'Australia',
  [ConstructionCluster.FRANCE]: 'France',
  [ConstructionCluster.GERMANY]: 'Germany',
  [ConstructionCluster.ITALY]: 'Italy',
  [ConstructionCluster.POLAND]: 'Poland',
  [ConstructionCluster.SPAIN_NETHERLANDS_GREECE]: 'Spain, Netherlands, Greece',
  [ConstructionCluster.UK_IRELAND]: 'UK & Ireland',
};
